import { connect } from "react-redux";
const Connect = props => {
  const {
    to,
    children,
    ...data
  } = props;
  return to && to.length ? children({
    ...data
  }) : null;
};
const mapStateToProps = (state, ownProps) => {
  const mapper = {};
  const props = ownProps.to || [];
  props.forEach(prop => {
    mapper[prop] = state[prop];
  });
  return mapper;
};
export default connect(mapStateToProps)(Connect);